import { call, put, takeLatest } from 'redux-saga/effects';
import {
	CATEGORY_RESTORE,
	CATEGORY_RESTORE_DONE,
	CATEGORY_RESTORE_LIST,
	CATEGORY_RESTORE_LIST_SUCCESS,
	CATEGORY_RESTORE_PRODUCTS,
	CATEGORY_RESTORE_PRODUCTS_SUCCESS,
	UPDATE_CATEGORY,
} from '../constants/category';
import { RECEIVE_PRODUCT } from '../constants/product';
import { ADD_NOTIFICATION, TAGS } from '../constants/notification';
import { requestHandler } from './fetcher.saga';
import { getMenuSelected } from './login';
import { I18n } from 'react-redux-i18n';
import moment from 'moment';

const ENTITY = 'category';

function* notify(key, params) {
	yield put({
		type: ADD_NOTIFICATION,
		notification: {
			tags: [TAGS.SUCCESS],
			text: I18n.t(key, params),
			date: moment().format('DD/MM/YYYY HH:mm'),
			viewed: false,
			openable: false,
		},
	});
}

function* fetchRemoved() {
	const id_menu = yield call(getMenuSelected);
	const { result } = yield call(requestHandler, ENTITY, 'GET', true, null, '/removed', {
		id_menu,
	});
	yield put({
		type: CATEGORY_RESTORE_LIST_SUCCESS,
		categories: result && Array.isArray(result.result) ? result.result : [],
	});
}

function* fetchRestorableProducts(action) {
	const id_menu = yield call(getMenuSelected);
	const { result } = yield call(
		requestHandler,
		ENTITY,
		'GET',
		true,
		null,
		'/restorable-products',
		{ id_menu, id_category: action.id_category }
	);
	yield put({
		type: CATEGORY_RESTORE_PRODUCTS_SUCCESS,
		id_category: action.id_category,
		products: result && Array.isArray(result.result) ? result.result : [],
	});
}

function* restore(action) {
	const id_menu = yield call(getMenuSelected);
	const { result } = yield call(requestHandler, ENTITY, 'POST', true, {
		id: action.id,
		id_menu,
		id_products: action.id_products || [],
	}, '/restore');

	if (result === false) {
		yield put({ type: CATEGORY_RESTORE_DONE });
		return;
	}

	// La catégorie et ses produits reviennent dans les listes : les deux
	// repartent du serveur, comme après n'importe quelle modification.
	const categories = yield call(requestHandler, ENTITY, 'GET', true, null, '', {
		id_menu,
	});
	const products = yield call(requestHandler, 'product', 'GET', true, null, '', {
		id_menu,
	});
	yield put({ type: UPDATE_CATEGORY, response: categories.result });
	yield put({ type: RECEIVE_PRODUCT, response: products.result });
	yield put({ type: 'REFRESH_DAY_CHANGES' });
	yield put({ type: CATEGORY_RESTORE_DONE });

	// Le message dit ce qui a été fait : remettre des produits en vente et les
	// rattacher ne sont pas le même geste, et l'un peut avoir eu lieu sans
	// l'autre.
	const restored = result && result.result ? result.result : {};
	const count = restored.products || 0;
	const linked = restored.linked || 0;
	let key = 'category.restore.done';
	if (count) {
		key = 'category.restore.doneWithProducts';
	} else if (linked) {
		key = 'category.restore.doneLinked';
	}
	yield call(notify, key, { name: restored.name || '', count, linked });
}

export function* watchListRemovedCategories() {
	yield takeLatest(CATEGORY_RESTORE_LIST, fetchRemoved);
}

export function* watchRestorableProducts() {
	yield takeLatest(CATEGORY_RESTORE_PRODUCTS, fetchRestorableProducts);
}

export function* watchRestoreCategory() {
	yield takeLatest(CATEGORY_RESTORE, restore);
}
